import { h } from "omi";

import { IconProps } from "@/components";

export function BookmarkIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width={width} height={height}>
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.6"
        d="M5 7.8c0-1.68016 0-2.52024.32698-3.16197.28762-.56449.74656-1.02343 1.31105-1.31105C7.27976 3 8.11984 3 9.8 3h4.4c1.6802 0 2.5202 0 3.162.32698.5645.28762 1.0234.74656 1.311 1.31105C19 5.27976 19 6.11984 19 7.8V21l-7-4-7 4V7.8Z"
      />
    </svg>
  );
}
